import clsx from 'clsx';
import * as React from 'react';
import { observer } from 'mobx-react';

import Image from '../Image';
import { Avatar } from '../../Avatar';
import { NotTranslated, translation, TranslationsContext } from '../../Translations';

interface Props {
  avatar: Avatar;
}

const PersonPhoto: React.FC<Props> = ({ avatar }) => {
  switch (avatar.kind) {
    case 'avatar-link':
      return (
        <TranslationsContext.Consumer>
          {(ts) => (
            <Image
              alt={translation('User Photo')(ts)}
              src={avatar.link.href}
              style={'h-full rounded-full'}
            />
          )}
        </TranslationsContext.Consumer>
      );
    case 'avatar-initials':
      return (
        <span
          className={clsx(
            'absolute inset-0 block max-w-full pt-2 text-center text-base font-medium text-white',
            'max-h-full rounded-full bg-[#187A90] group-hover:bg-[#194951] ',
          )}
        >
          <NotTranslated text={avatar.initials} />
        </span>
      );
  }
};

export default observer(PersonPhoto);
